import { useParams } from 'react-router-dom';

export const PrivacyPolicy = () => {
  return (
    <div className="p-20">
      <h1 className="text-5xl font-bold">PrivacyPolicy</h1>
    </div>
  );
};
